import React, { useState } from "react";
import mapIcon from "../../../../assets/images/map_v2/map-logo-black.svg";
import listIcon from "../../../../assets/images/map_v2/list-logo-black.svg";

type Props = {
  infoOpenMobile: boolean;
  setInfoOpenMobile: (open: boolean) => void;
  setEnteredThroughButton: (entered: boolean) => void;
};

const ToggleView = ({
  infoOpenMobile,
  setInfoOpenMobile,
  setEnteredThroughButton,
}: Props) => {
  const switchToListView = () => {
    setInfoOpenMobile(true);
    setEnteredThroughButton(true);
  };

  const switchToMapView = () => {
    setInfoOpenMobile(false);
  };

  return (
    <div className="toggle-wrapper">
      <button
        type="button"
        aria-pressed={!infoOpenMobile}
        className={`toggle-item ${!infoOpenMobile ? "selected" : ""}`}
        onClick={switchToMapView}
      >
        <img src={mapIcon} alt="Map" className="toggle-map-icon" />
        <span className="list-text">Map</span>
      </button>

      <button
        type="button"
        aria-pressed={infoOpenMobile}
        className={`toggle-item ${infoOpenMobile ? "selected" : ""}`}
        onClick={switchToListView}
      >
        <img src={listIcon} alt="List" className="toggle-list-icon" />
        <span className="list-text">List</span>
      </button>
    </div>
  );
};

export default ToggleView;
